import { render, staticRenderFns } from "./DetailDg.vue?vue&type=template&id=1524e70d&scoped=true"
import script from "./DetailDg.vue?vue&type=script&lang=js"
export * from "./DetailDg.vue?vue&type=script&lang=js"
import style0 from "./DetailDg.vue?vue&type=style&index=0&id=1524e70d&prod&scoped=true&lang=css"
import style1 from "./DetailDg.vue?vue&type=style&index=1&id=1524e70d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524e70d",
  null
  
)

export default component.exports